module.exports = __webpack_public_path__ + "img/sy.2505dfa5.svg";